import React, { useState } from 'react';

const AddFundsToGoalModal = ({ isOpen, onClose, onAddFunds, goal, fromAccounts }) => {
    const [amount, setAmount] = useState('');
    const [fromAccountId, setFromAccountId] = useState(fromAccounts[0]?.id || '');

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onAddFunds({ fromAccountId, toAccountId: goal.accountId, goalId: goal.id, amount });
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-sm shadow-xl">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Add Funds to "{goal.name}"</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Amount</label>
                        <input type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">From Account</label>
                        <select value={fromAccountId} onChange={(e) => setFromAccountId(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required>
                            {fromAccounts.map(acc => <option key={acc.id} value={acc.id}>{acc.name} (${acc.balance.toFixed(2)})</option>)}
                        </select>
                    </div>
                    <div className="flex justify-end space-x-3 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md">Add Funds</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddFundsToGoalModal;